import { Modal, PDFRenderer } from "components";
import { useMatch, useSearch } from "react-location";

import { LocationGenerics } from "router/location";
import config from "config";
import { processUrlData } from "utils/url";

export default function ViewInsurerPaymentReceiptContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const searchParams = useSearch<LocationGenerics>();
  const { params } = useMatch<LocationGenerics>();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="6xl"
      title="Payment Letter"
      description="Details of payment letter are shown below"
    >
      <PDFRenderer
        url={`${config.asset.uri}generate_payment_letter/${processUrlData({
          reinsurer_id: params?.reInsurer,
          offer_participant_payment_id: searchParams?.id,
        })
          }`}
      />
    </Modal>
  );
}
